import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { VendorActions } from "stores/VendorStore/vendorAction";

const mapStateToProps = (state) => {
  return {
    VendorRequestList: state.Vendors.VendorRequestList,
    ApproveEnableDisableList: state.Vendors.ApproveEnableDisableList,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getVendorRequestAction: VendorActions.getVendorSeeAllRequest,
      postApproveRequestAction: VendorActions.postApproveRequest,
    },
    dispatch
  );

const VendorRequestStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default VendorRequestStore;
